export default __webpack_public_path__ + "static/media/1-Ano-02-Meios-De-Transporte.f32dc191.png";